// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'payroll-organization-contribution.page.title': 'Payroll Organization Contributions',
    'payroll-organization-contribution.page.search_results': 'Search Results',
    'payroll-organization-contribution.page.create.title': 'Create New Payroll Organization Contribution',
    'payroll-organization-contribution.page.search.title': 'Find Payroll Organization Contributions',
    'payroll-organization-contribution.page.edit.title': 'Edit Payroll Organization Contribution',
    'payroll-organization-contribution.page.view.title': 'View Payroll Organization Contribution',
    'payroll-organization-contribution.page.all': 'All',

    'payroll-organization-contribution.button.cancel': 'Cancel',
    'payroll-organization-contribution.button.select': 'Select',
    'payroll-organization-contribution.button.find': 'Find Payroll Organization Contributions',
    'payroll-organization-contribution.button.search': 'Apply',
    'payroll-organization-contribution.button.create': 'Create Payroll Organization Contribution',
    'payroll-organization-contribution.button.new': 'New Payroll Organization Contribution',
    'payroll-organization-contribution.button.save': 'Save Changes',
    'payroll-organization-contribution.button.delete': 'Permanently Delete',
    'payroll-organization-contribution.button.edit': 'Edit',
    'payroll-organization-contribution.button.restore': 'Restore',
    'payroll-organization-contribution.button.reset': 'Reset',

    'payroll-organization-contribution.placeholder.search': 'Search payroll organization contributions',

    'payroll-organization-contribution.link.create_first_payroll_organization_contribution': 'Click here to create your first payroll organization contribution',
    'payroll-organization-contribution.link.payroll_organization_contributions': ' Return to Payroll Organization Contributions',
    'payroll-organization-contribution.link.retry': 'Click here to retry',

    'payroll-organization-contribution.checkbox.all': 'Check All',
    'payroll-organization-contribution.checkbox.actions_label': 'with selected',

    'payroll-organization-contribution.label.from__used_on': 'From used on',
    'payroll-organization-contribution.label.to__used_on': 'To used on',
    'payroll-organization-contribution.label.used_on': 'Used On',

    'payroll-organization-contribution.label.from__amount_in_cents': 'From amount in cents',
    'payroll-organization-contribution.label.to__amount_in_cents': 'To amount in cents',
    'payroll-organization-contribution.label.amount_in_cents': 'Amount In Cents',

    'payroll-organization-contribution.label.from__created_at': 'From created at',
    'payroll-organization-contribution.label.to__created_at': 'To created at',
    'payroll-organization-contribution.label.created_at': 'Created At',

    'payroll-organization-contribution.label.from__updated_at': 'From updated at',
    'payroll-organization-contribution.label.to__updated_at': 'To updated at',
    'payroll-organization-contribution.label.updated_at': 'Updated At',

    'payroll-organization-contribution.label.from__deleted_at': 'From deleted at',
    'payroll-organization-contribution.label.to__deleted_at': 'To deleted at',
    'payroll-organization-contribution.label.deleted_at': 'Deleted At',

    'payroll-organization-contribution.label.status': 'Status',

    'payroll-organization-contribution.sort.field_label': 'Field',
    'payroll-organization-contribution.sort.direction_label': 'Direction',
    'payroll-organization-contribution.sort.direction_ascending': 'Ascending',
    'payroll-organization-contribution.sort.direction_descending': 'Descending',

    'payroll-organization-contribution.modal.title.payroll_organization_contribution_delete_permanently': 'Delete Payroll Organization Contribution',
    'payroll-organization-contribution.modal.title.payroll_organization_contribution_restore': 'Restore Payroll Organization Contribution',

    'payroll-organization-contribution.modal.message.payroll_organization_contribution_delete_permanently':
        'Are you sure that you want to permanently delete this payroll organization contribution? This action cannot be undone. | Are you sure that you want to permanently delete these payroll organization contributions? This action cannot be undone.',
    'payroll-organization-contribution.modal.message.payroll_organization_contribution_restore':
        'Are you sure that you want to restore this payroll organization contribution? | Are you sure that you want to restore these payroll organization contributions?',

    'payroll-organization-contribution.success.message.payroll_organization_contribution_created': 'Your payroll organization contribution has been created',
    'payroll-organization-contribution.success.message.payroll_organization_contribution_updated': 'Your payroll organization contribution has been updated',
    'payroll-organization-contribution.success.message.payroll_organization_contribution_restored': 'Your payroll organization contribution has been restored | All selected payroll organization contributions were restored',
    'payroll-organization-contribution.success.message.payroll_organization_contribution_deleted':
        'Your payroll organization contribution has been permanently deleted | All selected payroll organization contributions were permanently deleted',

    'payroll-organization-contribution.error.message.payroll_organization_contribution_deleted':
        'This payroll organization contribution was already permanently deleted | These payroll organization contributions were already permanently deleted',
    'payroll-organization-contribution.error.message.payroll_organization_contribution_restored': 'This payroll organization contribution was already restored | These payroll organization contributions were already restored',
    'payroll-organization-contribution.error.message.error_loading_page': 'Sorry, there was an error loading payroll organization contribution.| Sorry, there was an error loading payroll organization contributions.',
};
